export default __webpack_public_path__ + "static/dawgs-c33d0b7a70985fa8495f0ef2ac8ad968.png";